import type { filet as Fr } from '../fr/filet';

/** « filet » in English — typed on the French: a missing sentence does not compile. */
export const filet: typeof Fr = {
  titre: 'This screen could not be displayed',
  pasPerdues: 'Your data is not lost.',
  rienModifie: ' Nothing was changed: this error happened while displaying the page, not while saving.',
  continuer: 'You can keep working on the other screens. If the problem comes back, report it and say which screen you were on.',
  revenir: 'Back to Today',
  reessayer: 'Try again',
  detail: 'Technical details',
};
